module.exports = __webpack_public_path__ + "static/media/file.a026a212.png";